import { isNil } from 'lodash';

import StorefrontApi from 'api/Storefront';
import { SEARCH_OPERATIONS, SEARCH_QUERIES } from 'constants/storefront';

class StorefrontPredictiveSearch {
  static predictiveSearchQueries = async ({ queryToSearch, limitResult }) => {
    if (isNil(queryToSearch)) {
      throw new Error('Predictive search query to search is a required value');
    }

    if (!Number.isInteger(limitResult)) {
      throw new Error('Predictive search result limit is a numeric required value');
    }

    const variables = { queryToSearch, limitResult };
    const gqlQuery = SEARCH_QUERIES.PREDICTIVE_SEARCH_QUERIES_QUERY;
    const operationName = SEARCH_OPERATIONS.PREDICTIVE_SEARCH;

    const apiCallResult = await StorefrontApi.call({
      query: gqlQuery,
      variables,
      operationName,
    });

    return {
      queriesObjResult: apiCallResult?.queries,
    };
  };
}

export default StorefrontPredictiveSearch;
